<template>
  <div id="AppBody">
    <div class="contentBox mainView" >
      <router-view v-if="selectedClient"/>
    </div>
    <RightHandRail v-if="showRightHandRail"/>
    <VideoPlayer :video="currentVideo" v-if="currentVideo"/>
  </div>
</template>

<script>
import RightHandRail from '../components/RightHandRail.vue'
import VideoPlayer from '../components/VideoPlayer.vue'
import store from '../store.js'

export default {
  name: 'Client',
  components: {
    VideoPlayer,
    RightHandRail
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.id != this.$store.state.selectedClient) {
      this.$store.commit('changeSelectedClient',to.params.id)
      this.$store.dispatch("preflightChecks").then(()=>{
        if (to.params.id) {
          next()
        } else {
          var client = '/c/' + store.state.selectedClient + '/videos'
          next(client)
        }

      })
      this.$store.dispatch('fireFetchVideos');
    } else {
      next()
    }
    //store.dispatch('fireFetchCreativeDirections')
    //store.dispatch('fetchDeliveryBatches');

  },
  created: function(){
    this.$store.dispatch('fireFetchVideos');
  },
  beforeRouteEnter (to, from, next) {
    //console.log("route enter");
    if (to.params.id) {
      if (to.params.id != store.state.selectedClient) {
        store.commit('changeSelectedClient',to.params.id)
      }
      store.dispatch("preflightChecks").then(()=>{
        next()
      })

    } else {
      store.dispatch("preflightChecks").then(()=>{
        var client = '/c/' + store.state.selectedClient + '/videos'
        next(client)
      })
    }
  },
  computed: {
    showRightHandRail () {
      if (this.$route.query.view) {
        if (this.$route.query.view === "queue") {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    sectionLinks () {
      var linkOutput = []
      //var currentRoute = this.$route
      this.linkData.forEach((link)=>{
        if (this.$store.getters.isAdmin || !link.admin) {
          linkOutput.push({
            name: link.name,
            selected: (link.routeName === this.$route.name),
            route: { name: link.routeName, params: { id: this.$route.params.id }}
          })
        }
      })

      return linkOutput
    },
    selectedClient () {
      return this.$store.state.selectedClient;
    },
    currentVideo () {
      var videoID = this.$store.state.currentVideo
      return this.$store.state.deliverableCollection[videoID]
    },
    activeFilters(){
      return this.$store.state.activeFilters
    },
  },
  methods: {
    handleChangeFilter(value){
      this.selectedFilter = parseInt(value);
    },
    removeFilter(filterIndex){
      this.$store.commit('removeFilter',filterIndex);
    },
    visibleTemplateColumns() {
      var columnOutput = ""
      Object.keys(this.childObjects).forEach((item) => {
        if (this.childObjects[item].visible) {
          columnOutput += this.childObjects[item].columnWidth + " "
        }
      })
      return columnOutput
    }
  }
}
</script>

<style>
  #AppBody {
    display: flex;
    overflow: hidden;
    padding: 10px 10px 10px 80px;
    flex-grow: 1;
    z-index: 10;
  }
  .mainView {
    flex-grow: 1;
  }
</style>
